import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, useLoginWithRedirect } from '@frontegg/react';
import AuthService from '../services/auth.service';

export default function Login() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const loginWithRedirect = useLoginWithRedirect();
  const authService = AuthService.getInstance();

  useEffect(() => {
    if (isAuthenticated) {
      const returnPath = localStorage.getItem('returnPath') || '/';
      localStorage.removeItem('returnPath');
      navigate(returnPath, { replace: true });
    } else if (authService.ssoLoginUrl) {
      // Custom domain with SSO configured — redirect directly to SSO provider
      window.location.href = authService.ssoLoginUrl;
    } else if (authService.useExternalLogin) {
      // Redirect to the legacy frontend for login since OAuth redirect URL is only configured there
      window.location.href = `${authService.authAppUrl}/login`;
    } else {
      // Redirect to Frontegg's login
      loginWithRedirect();
    }
  }, [isAuthenticated, navigate, loginWithRedirect]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Redirecting to login...</div>
    </div>
  );
}

